<template>
	<div class="card">
		<h3 class="title">
			<img
				:src="iconExchangeDetailTitle"
				alt=""
				style="width: 24px; height: 24px"
			/>
			{{ $t('rtr_activity-exchange.title1') }}
		</h3>
	</div>
	<div class="card type1 mb_0 pt_40 pb_40">
		<div class="card_inner">
			<h3 class="title mb_40 justify_center">
				{{ $t('rtr_activity-exchange.detail.title1') }}
			</h3>
			<table class="table_type table_type_detail">
				<colgroup>
					<col style="width: 250px" />
				</colgroup>
				<tbody>
					<tr>
						<th v-if="exchangeInfo.transfer_type === 'BID'">
							{{ $t('rtr_activity-exchange.detail.th1') }}
						</th>
						<th v-else>{{ $t('rtr_activity-exchange.detail.th12') }}</th>
						<td>{{ exchangeInfo.source_asset_title }}</td>
					</tr>
					<tr>
						<th>{{ $t('rtr_activity-exchange.detail.th2') }}</th>
						<td>{{ exchangeInfo.target_asset_title }}</td>
					</tr>
					<tr>
						<th v-if="exchangeInfo.transfer_type === 'BID'">
							{{ $t('rtr_activity-exchange.detail.th3') }}
						</th>
						<th v-else>{{ $t('rtr_activity-exchange.detail.th13') }}</th>
						<td>{{ exchangeInfo.source_amount }}</td>
					</tr>
					<tr>
						<th>{{ $t('rtr_activity-exchange.th4') }}</th>
						<td>{{ exchangeInfo.target_amount }}</td>
					</tr>
					<tr>
						<th v-if="exchangeInfo.transfer_type === 'BID'">
							{{ $t('rtr_activity-exchange.detail.th5') }}
						</th>
						<th v-else>{{ $t('rtr_activity-exchange.detail.th14') }}</th>
						<td>
							{{ exchangeInfo.source_account_number }}
						</td>
					</tr>
					<tr>
						<th>{{ $t('rtr_activity-exchange.detail.th6') }}</th>
						<td>{{ exchangeInfo.target_account_number }}</td>
					</tr>
					<tr>
						<th>{{ $t('rtr_activity-exchange.th5') }}</th>
						<td>{{ exchangeInfo.basic_rate }}</td>
					</tr>
					<tr>
						<th>{{ $t('rtr_activity-exchange.th6') }}</th>
						<td>
							{{ exchangeInfo.spread_rate }}
						</td>
					</tr>
					<tr>
						<th>{{ $t('rtr_activity-exchange.th7') }}</th>
						<td>
							{{ exchangeInfo.exchange_rate }}
						</td>
					</tr>
					<tr>
						<th>{{ $t('rtr_activity-exchange.detail.th10') }}</th>
						<td>
							<span
								v-if="exchangeInfo.transfer_type === 'BID'"
								class="label_buy"
								>{{ $t('rtr_activity-exchange.buy') }}</span
							>
							<span v-else class="label_sell">{{
								$t('rtr_activity-exchange.sell')
							}}</span>
						</td>
					</tr>
					<tr>
						<th>{{ $t('rtr_activity-exchange.detail.th11') }}</th>
						<td>
							{{ $dayjs(exchangeInfo?.regdate).format('YYYY.MM.DD HH:mm:ss') }}
						</td>
					</tr>
				</tbody>
			</table>
			<div :class="['button_area', 'tac', isMobile ? 'mt_20' : 'mt_50']">
				<button
					:class="['button_bg_blue', isMobile ? 'w100' : '']"
					@click="$emit('back')"
				>
					{{ $t('button.back') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import iconExchangeDetailTitle from '@/assets/images/v2/icon/icon-exchange-detail-title.svg';

export default {
	name: 'ExchangeDetail',
	data() {
		return {
			iconExchangeDetailTitle: iconExchangeDetailTitle,
			isMobile: false,
		};
	},
	props: {
		exchangeInfo: {
			type: Object,
		},
	},
	created() {
		window.scrollTo(0, 0);
		this.checkMobile();
	},
	mounted() {
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		checkMobile() {
			this.isMobile = window.innerWidth <= 768;
		},
	},
};
</script>
